// @flow
import React, { useMemo, type Node } from 'react';
import { useTranslation } from 'react-i18next';

import { Api, createApiContext, pickDescription } from 'app/common/context/Api';
// $FlowFixMe
import shopApi from 'app/actions/shopApi';


/**
 * Офрмление заказа (post)
 */

const apiId = 'orderPost';

type Receiver = {
  name: string,
  email: string,
  phone: string,
  user_uuid: string,
}

export type RequestDataProps = {
  cart_id: string,
  order: {
    user_uuid: string,
    payment_method_id: number,
    shipping_method_id: number,
    delivery_point_uuid: string,
    name: string,
    email: string,
    phone: string,
    postal_code?: string,
    city?: string,
    street?: string,
    comment?: string,
    is_callback?: boolean,
    receivers: Array<Receiver>,
  },
}

const cbErrorTextCreate = t => (/* error */) => (t('error_api_orders_post'));

type Request = {
  orderPost: (void) => void | Promise<void>,
}

const initialRequest = {
  orderPost: () => {},
};

type Content = {}

const initialContent = {};

export type OrderPostState = {
  content: Content,
  loading: boolean,
  request: Request,
  error?: { [string]: mixed },
}

export const OrderPost = createApiContext<Content, Request>(initialContent, initialRequest);

export type OrderPostProps = {
  children: Node | (value: OrderPostState) => Node,
  data: RequestDataProps,
}

const OrderPostApi = ({ children, data }: OrderPostProps) => {
  const { t } = useTranslation('shop');

  const descriptions = useMemo(() => pickDescription({
    id: apiId,
    requestPath: 'orders',
    requestType: 'post',
    requestParams: data,
    cbErrorTextCreate: cbErrorTextCreate(t),
    autoRequest: false,
  }), [data, t]);

  return (
    <Api
      fnApi={shopApi}
      apiData={OrderPost}
      descriptions={descriptions}
      initialContent={initialContent}
    >
      {children}
    </Api>
  );
};

export default OrderPostApi;
